import React from "react";
import SectionHeading from "./SectionHeading";
import { PROJECTS } from "./data/content";
import { FaGithub, FaDribbble } from "react-icons/fa";
import { useIntersectionObserver } from "./useIntersectionObserver";

const LINK_ICONS = {
  github: FaGithub,
  dribbble: FaDribbble,
};

function Projects() {
  const ref = React.useRef(null);
  const [inView] = useIntersectionObserver(ref);

  return (
    <section
      id="work"
      className={"site-section" + (inView ? " section-is-visible" : "")}
      ref={ref}
    >
      <div className="section-inner">
        <SectionHeading
          label="Work & builds"
          title="Things I've built"
          description="Bootcamp projects, volunteer work, and this site."
        />

        <div className="work-grid reveal-item" style={{ "--item-index": 0 }}>
          {PROJECTS.map((project, index) => (
            <article
              key={project.id}
              className={
                "work-card glass-card work-card--" +
                project.accent +
                (project.featured ? " work-card--featured" : "") +
                (!project.image ? " work-card--no-media" : "")
              }
            >
              {project.image && (
                <div className="work-card-media">
                  <img src={project.image} alt={project.title} loading="lazy" />
                </div>
              )}

              <div className="work-card-body">
                <h3 className="work-card-title">{project.title}</h3>
                <ul className="work-card-stack">
                  {project.stack.map((tech) => (
                    <li key={tech}>{tech}</li>
                  ))}
                </ul>
                <p className="work-card-desc">{project.description}</p>

                {project.links.length > 0 && (
                  <div className="work-card-links">
                    {project.links.map((link) => {
                      const Icon = LINK_ICONS[link.type];
                      return (
                        <a
                          key={link.href}
                          href={link.href}
                          className="work-card-link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {Icon && <Icon aria-hidden="true" />}
                          {link.label}
                        </a>
                      );
                    })}
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
